import { render, staticRenderFns } from "./MessageTitle.vue?vue&type=template&id=17b8dfbc&scoped=true"
import script from "./MessageTitle.vue?vue&type=script&lang=js"
export * from "./MessageTitle.vue?vue&type=script&lang=js"
import style0 from "./MessageTitle.vue?vue&type=style&index=0&id=17b8dfbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b8dfbc",
  null
  
)

export default component.exports